// Homepage closing call to action (EN + FR). The phone number is used for both languages,
// so it is only on the English side.
const CTA_DEFAULTS = {
  "en": {
    "title": "Need security in Montreal, Toronto or Ottawa?",
    "copy": "Licensed guards, mobile patrols and event teams — free quote {quoteReply}, urgent staffing {urgent}.",
    "buttonLabel": "Get a Free Quote",
    "orLabel": "or call us",
    "phone": "514-279-7209"
  },
  "fr": {
    "title": "Besoin de sécurité à Montréal, Toronto ou Ottawa ?",
    "copy": "Agents licenciés, patrouilles mobiles et équipes événementielles — soumission gratuite {quoteReply}, déploiement urgent {urgent}.",
    "buttonLabel": "Obtenir une soumission gratuite",
    "orLabel": "ou appelez-nous"
  }
};

export default CTA_DEFAULTS;
